import { render, staticRenderFns } from "./AllSynatecOrders.vue?vue&type=template&id=33aea98d&scoped=true&"
import script from "./AllSynatecOrders.vue?vue&type=script&lang=js&"
export * from "./AllSynatecOrders.vue?vue&type=script&lang=js&"
import style0 from "./AllSynatecOrders.vue?vue&type=style&index=0&id=33aea98d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aea98d",
  null
  
)

export default component.exports